/**
 * The available steps of the contract wizard
 */
export const STEP_KPP_VEHICLE = 'Fahrzeug';
export const STEP_KPP_TERM = 'Laufzeit';
export const STEP_EP_VEHICLE = 'ep-Fahrzeug';
export const STEP_TERM_KEH = 'keh-term';
export const STEP_CLIENT = 'Kunde';
export const STEP_CLIENT_DATA_1 = 'Contact';
export const STEP_CLIENT_DATA_2 = 'ClientData2';
export const STEP_PAYMENT = 'Konto';
// review
export const STEP_REVIEW = 'Abschluss.';
export const STEP_KPP_REVIEW = 'Abschluss';
export const STEP_EP_REVIEW = 'ep-Abschluss';
export const FORM_REVIEW_KEH = 'Abschluss ';

export const STEP_AGREEMENT = 'Agreement';
export const STEP_AGREEMENT_KEH = 'Agreement-KEH';

// export const STEP_SIGNATURE = 'Signature';
export const STEP_INSURANCE = 'Versicherung';
